export const HEADER_BANNER_DOMAIN = 'headerBanner'
export const HEADER_BANNER_STATE = {
  id: null
}

export const HEADER_BANNER_ID = {
  NEW_CUSTOMER_DISCOUNT_TIMER: 'NEW_CUSTOMER_DISCOUNT_TIMER'
}

export const HEADER_BANNER_HEIGHT_DESKTOP = '40px'
export const HEADER_BANNER_HEIGHT_SMALL_SCREEN = '36px'
